export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    btc: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    btc: 0,
    source: ""
  },
]
